package styles

enum class EColors(val value: String) {
    // ----------------------------------------------------------------------------
    // Enumeration List
    // ----------------------------------------------------------------------------

    COLOR_BLUE_DARK("#17224b"),
    COLOR_BLUE_LIGHT("#33a8e0"),
    COLOR_ORANGE("#e97226"),
    COLOR_GREY("#777777"),

    BASKETS_WEBSITE_BLUE_DARK("#142033"),
    BASKETS_WEBSITE_BLUE_DARK_VARIANT("#253145"),
    BASKETS_WEBSITE_BLUE_TABLE_HEADERS_DARK("#163971"),
    BASKETS_WEBSITE_ORANGE_HEADLINE("#F39C4C")

    // ----------------------------------------------------------------------------
    // Public methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Protected methods
    // ----------------------------------------------------------------------------

    // ----------------------------------------------------------------------------
    // Private methods
    // ----------------------------------------------------------------------------
}